import {CSSObjectWithLabel, StylesConfig} from "react-select";

import {IOption} from "@pg-design/select-module";

interface IParams {
    hideIcons: boolean;
    isMobile: boolean | null;
}

const withoutWizardInputChrome = (provided: CSSObjectWithLabel) => {
    const rest = {...provided};

    delete rest.border;
    delete rest.borderColor;
    delete rest.padding;
    delete rest.paddingBottom;
    delete rest.paddingLeft;
    delete rest.paddingRight;
    delete rest.paddingTop;

    return rest;
};

const getControlStyle = (provided: CSSObjectWithLabel, hideIcons: boolean): CSSObjectWithLabel => {
    const providedStyle = hideIcons ? withoutWizardInputChrome(provided) : provided;

    return {
        ...providedStyle,
        ...(!hideIcons && {
            border: "none",
            borderColor: "transparent",
            padding: "calc(var(--globals-baseUnit) * 1.5)",
            paddingLeft: "calc(var(--globals-baseUnit) * 1.5 + var(--globals-baseUnit) * 4)"
        }),
        ...(hideIcons && {
            alignItems: "center",
            flexWrap: "nowrap",
            height: "6.4rem",
            overflow: "hidden",
            padding: "0.8rem"
        }),
        ["&:hover"]: {
            ...(provided["&:hover"] as object),
            ...(hideIcons && {borderColor: "var(--colors-gray-900)"})
        },
        ["&:focus"]: {...(provided["&:focus"] as object)},
        ["&:active"]: {...(provided["&:active"] as object), outline: "none"},
        borderRadius: hideIcons ? "0.8rem" : "4rem",
        boxShadow: "none",
        minHeight: hideIcons ? "6.4rem" : "4.8rem",
        outline: "none"
    };
};

// Slots restyled only for the wizard (no icons), where the field is a single nowrap row.
const getWizardSlotStyles = (isMobile: boolean | null): StylesConfig<IOption<number>, true> => ({
    input: (provided, state) => ({
        ...provided,
        margin: 0,
        ...(!state.hasValue && {marginLeft: "0.8rem"})
    }),
    multiValue: (provided) => ({
        ...provided,
        margin: 0
    }),
    placeholder: (provided) => ({
        ...provided,
        marginLeft: "0.8rem",
        ...(isMobile && {
            marginRight: "0.8rem",
            overflow: "hidden"
        })
    }),
    valueContainer: (provided) => ({
        ...provided,
        flexWrap: "nowrap",
        gap: "0.8rem",
        overflow: "hidden",
        padding: 0
    })
});

export const getHomeMatchUserPreferencesLocationSelectStyles = (params: IParams): StylesConfig<IOption<number>, true> => {
    const {hideIcons, isMobile} = params;

    return {
        control: (provided) => getControlStyle(provided, hideIcons),
        ...(hideIcons && getWizardSlotStyles(isMobile))
    };
};
import {CSSObjectWithLabel, StylesConfig} from "react-select";

import {IOption} from "@pg-design/select-module";

interface IParams {
    hideIcons: boolean;
    isMobile: boolean | null;
}

const withoutWizardInputChrome = (provided: CSSObjectWithLabel) => {
    const rest = {...provided};

    delete rest.border;
    delete rest.borderColor;
    delete rest.padding;
    delete rest.paddingBottom;
    delete rest.paddingLeft;
    delete rest.paddingRight;
    delete rest.paddingTop;

    return rest;
};

const getControlStyle = (provided: CSSObjectWithLabel, hideIcons: boolean): CSSObjectWithLabel => {
    const providedStyle = hideIcons ? withoutWizardInputChrome(provided) : provided;

    return {
        ...providedStyle,
        ...(!hideIcons && {
            border: "none",
            borderColor: "transparent",
            padding: "calc(var(--globals-baseUnit) * 1.5)",
            paddingLeft: "calc(var(--globals-baseUnit) * 1.5 + var(--globals-baseUnit) * 4)"
        }),
        ...(hideIcons && {
            alignItems: "center",
            flexWrap: "nowrap",
            height: "6.4rem",
            overflow: "hidden",
            padding: "0.8rem"
        }),
        ["&:hover"]: {
            ...(provided["&:hover"] as object),
            ...(hideIcons && {borderColor: "var(--colors-gray-900)"})
        },
        ["&:focus"]: {...(provided["&:focus"] as object)},
        ["&:active"]: {...(provided["&:active"] as object), outline: "none"},
        borderRadius: hideIcons ? "0.8rem" : "4rem",
        boxShadow: "none",
        minHeight: hideIcons ? "6.4rem" : "4.8rem",
        outline: "none"
    };
};

// Slots restyled only for the wizard (no icons), where the field is a single nowrap row.
const getWizardSlotStyles = (isMobile: boolean | null): StylesConfig<IOption<number>, true> => ({
    input: (provided, state) => ({
        ...provided,
        margin: 0,
        ...(!state.hasValue && {marginLeft: "0.8rem"})
    }),
    multiValue: (provided) => ({
        ...provided,
        margin: 0
    }),
    placeholder: (provided) => ({
        ...provided,
        marginLeft: "0.8rem",
        ...(isMobile && {
            marginRight: "0.8rem",
            overflow: "hidden"
        })
    }),
    valueContainer: (provided) => ({
        ...provided,
        flexWrap: "nowrap",
        gap: "0.8rem",
        overflow: "hidden",
        padding: 0
    })
});

export const getHomeMatchUserPreferencesLocationSelectStyles = (params: IParams): StylesConfig<IOption<number>, true> => {
    const {hideIcons, isMobile} = params;

    return {
        control: (provided) => getControlStyle(provided, hideIcons),
        ...(hideIcons && getWizardSlotStyles(isMobile))
    };
};
